import { render, staticRenderFns } from "./AlwaysShowOwnBoardsSetting.vue?vue&type=template&id=9edd5d8c"
import script from "./AlwaysShowOwnBoardsSetting.vue?vue&type=script&lang=ts"
export * from "./AlwaysShowOwnBoardsSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports